import React, { Component } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";

import Cart from "./Cart";
import NutritionalFacts from "../../ActionButton/NutritionalFacts";
import TotalCharge from "./TotalCharge";
import ActionButton from "../../ActionButton";
import DeliverTo from "./DeliverTo";
import PaymentMethod from "./PaymentMethod";
import AdditionalInformation from "../../AreaSelect/Pickup/AdditionalInformation";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import instance from "../../../store/actions/instance";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  saveLastOrder,
  savePastOrder,
  setProduct,
} from "../../../store/actions";
import moment from "moment";
import StoreClosedDialog from "../../ProductDetails/StoreClosedDialog";
import { compareTime } from "../../Branches/ContactPageTools";
import { clearCart, updatePromotions } from "../../../store/actions/cart";
import { createCustomerWithAddressAndPhone } from "../../../store/actions/auth";

import Popover from "@material-ui/core/Popover";
import UnclaimedPromoDialog from "../../UnClamiedPromoDialog";
import { preciseNumber } from "../../../store/reducers/cart";
import { registerGlanceView } from "../../../store/actions/analytics";
import {
  fetchDeliveryTime,
  setDrawer,
  updatePromotion,
} from "../../../store/actions/deliveryTime";
import DeliveryTimeV2 from "./DeliveryTimeV2";
import { getOrderDiscount } from "../../../Helpers/promotions";
import _ from "lodash";
import StaticPages from "../../StaticPages";
import * as Sentry from "@sentry/react";
import "./Card.css";
import ProductRecommendations from "../../ProductDetails/ProductRecommendations";
import Shipping from "./Shipping";

import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Checkbox from "@material-ui/core/Checkbox";
import RestaurantIcon from "@material-ui/icons/Restaurant";
import { resetFilter } from "../../../store/actions/productFilter";
import CheckBoxIcon from "@material-ui/icons/CheckBoxOutlined";
import { getProduct } from "../../../store/reducers/store";
import VerifyPhone from "../FirstStep/VerifyPhone";
import AppliedCoupons from "./AppliedCoupons";
import Gift from "./Gift";
import AramexShipping from "./AramexShipping";
import SpecialRemarksFile from "./SpecialRemarksFile";
import { shouldShowNumberError } from "../../../Helpers/gift";
import { getCurrencyIso } from "../../../Helpers/currencyConverter";
import parsePhoneNumberFromString from "libphonenumber-js";
import { isValidPhoneNumber } from "react-phone-number-input";
import {
  canUseSocialAuth,
  getSavedAddresses,
  shouldRequireOrderPassVerification,
} from "../../../Helpers/orderPass";

function normalizeSaudiNationalAddress(code) {
  if (typeof code !== "string") return "";

  return code
    .toUpperCase()
    .replace(/[\s\u200B-\u200F\u202A-\u202E\u2060\uFEFF]/g, "");
}

function isValidSaudiNationalAddress(code) {
  const normalized = normalizeSaudiNationalAddress(code);

  // 4 letters (A-Z) followed by 4 digits (0-9)
  const regex = /^[A-Z]{4}[0-9]{4}$/;

  return regex.test(normalized);
}

function isMobileOrTablet() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}

const isVirginPhoneNumber = (phone) => {
  // For Virgin Mobile Kuwait. Numbers are 8 digits long and start with 41
  if (!phone) return false;
  if (
    phone.startsWith("+965") &&
    phone.split("+965")[1].startsWith("41") &&
    phone.split("+965")[1].length === 8
  )
    return true;
  return false;
};
const getPhoneDigits = (phone) => (phone || "").replace(/\D/g, "");
const isEgyptPhone = (phone) => getPhoneDigits(phone).startsWith("20");
const isEgyptianMobilePhoneNumber = (phone) => {
  if (!phone) return false;
  const digits = getPhoneDigits(phone);
  if (!digits.startsWith("20")) return false;
  const nationalNumber = digits.slice(2);
  if (nationalNumber.startsWith("0")) {
    return /^(010|011|012|015)\d{8}$/.test(nationalNumber);
  }
  return /^(10|11|12|15)\d{8}$/.test(nationalNumber);
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const OfflinePaymentsMethods = [
  "cash",
  "kod",
  "benefit-transfer",
  "pos",
  "payment days",
  "on-credit",
  "wallet",
  "wallet,cash",
  "cash,wallet",
  "wallet,kod",
  "kod,wallet",
  "wallet,benefit-transfer",
  "loyalty points",
  "loyalty points,cash",
  "cash,loyalty points",
  "loyalty points,kod",
  "kod,loyalty points",
  "loyalty points,benefit-transfer",
];

const isCarInfoRequired = (branch, props) => {
  const { settings, branches } = props;
  let req_branch = branches.find((b) => b.id === branch);
  if (
    settings.is_branch_based_ordering &&
    req_branch &&
    req_branch.ask_for_car_info &&
    branch
  ) {
    return {
      make_is_required: req_branch?.make_is_required,
      color_is_required: req_branch?.color_is_required,
      plate_is_required: req_branch?.plate_is_required,
    };
  } else if (!settings.is_branch_based_ordering && settings.ask_for_car_info) {
    return {
      make_is_required: settings.make_is_required,
      color_is_required: settings.color_is_required,
      plate_is_required: settings.plate_is_required,
    };
  }

  return {
    make_is_required: false,
    color_is_required: false,
    plate_is_required: false,
  };
};
class index extends Component {
  categoriesMinList = [];
  static defaultProps = {
    highlightColor: "#0099cc",
  };
  state = {
    method: localStorage.getItem("orderPlacedById")
      ? "cash" // to force cash incase the order was from the create order iframe
      : this.props.settings.enable_table_qr &&
          !this.props.settings.dine_in_payment_required
        ? "cash"
        : this.props.paymentMethod || "none",
    loading: false,
    special_remarks: "",
    placeOrderButtonEnabled: false,
    paymentError: false,
    busyDialogOpen: false,
    carInfoIsRequired: isCarInfoRequired(this.props.branch.branch, this.props),
    //MOV
    anchorEl: null,

    //PROMO,
    dialogOpen: false,
    pending_items: [],
    pending_category: [],

    staticPagesCheckableEnabled: false,
    staticPagesCheckableChecked: false,

    deliveryTimeFetchesCount: 0,

    tapCardError: "",
    recommendationVisibilityRegistered: false,
    no_cutlery: this.props.settings.enable_no_cutlery
      ? this.props.settings.enable_no_cutlery_by_default
      : false,

    useCustomerWallet: this.props.paymentMethod === "wallet" ? true : false,
    useCustomerPoints:
      this.props.paymentMethod === "loyalty points" ? true : false,

    fromUnclaimedPromoContinue: false,
    fromActionButton: false,
    vatAmount: 0,

    nutritionalFacts: {},
    errorName:
      this.props.settings.enable_force_gift_name_number &&
      !this.props.promise.gift_name,
    errorNumber: shouldShowNumberError(this.props),
  };

  recommendationsRef = React.createRef();

  setStaticPagesCheckableEnabled = (state) => {
    this.setState({
      staticPagesCheckableEnabled: state,
    });
  };

  setStaticPagesCheckableChecked = (state) => {
    this.setState({
      staticPagesCheckableChecked: state,
    });
  };

  handleChange = (value) => {
    this.setState({ method: value, paymentError: false });
    this.props.setPaymentMethod(value);
    if (value === "tap_v2_credit") {
      setTimeout(
        () =>
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth",
          }),
        200,
      );
    }
    if (this.props.customerBin) {
      this.props.setCustomerBIN(null); // maybye use localStorage?????
      if (
        this.props.smart_promos.some((sp) =>
          sp.conditions.some((c) =>
            ["card_scheme", "card_bank"].includes(c.type),
          ),
        )
      ) {
        this.props.updatePromotions();
        if (window.tapCardObject) {
          window.tapCardObject.clearForm();
        }
      }
    }
    const { settings } = this.props;
  };

  getTotal = (
    price,
    promo,
    discounts,
    total_discount,
    deliveryCharge,
    showDelivery,
    loyaltyPointConvert = 0,
  ) => {
    const { settings } = this.props;
    if (
      showDelivery &&
      deliveryCharge &&
      this.props.address &&
      this.props.address.selectedDeliveryType === 0
    ) {
      if (
        (!promo || (promo && promo.discount_type !== "delivery")) &&
        !discounts.delivery.length
      ) {
        price += deliveryCharge;
      } else if (discounts.delivery.length) {
        deliveryCharge =
          deliveryCharge -
          deliveryCharge *
            ((discounts.delivery[0].discount_amount || 100) / 100);

        price += deliveryCharge;
      }
    }
    if (
      settings.enable_gifts &&
      settings.enable_gifts_staff &&
      settings.enable_gift_wrapping &&
      settings.gift_wrapping_price > 0 &&
      this.props.promise.isGift === true &&
      this.props.promise.gift_wrapping === true
    ) {
      price += settings.gift_wrapping_price;
    }

    if (
      this.props.settings.enable_additional_fee &&
      this.state.method != "none"
    )
      return price + this.props.settings.additional_fee;
    price -= total_discount;
    if (
      loyaltyPointConvert > 0 &&
      this.state.useCustomerPoints &&
      this.props.settings.enable_loyalty_points_staff &&
      this.props.settings.enable_loyalty_points &&
      this.props.settings.enable_loyalty_points_payment
    ) {
      price -= loyaltyPointConvert;
    }
    if (price <= 0) price = 0;
    return price;
  };

  shouldShowDeliveryTime = () => {
    const { deliveryTime, settings, cart } = this.props;
    if (cart.delivered_items == 0) return false;
    if (deliveryTime.loading) return false;
    if (settings.enable_delivery) {
      if (settings.enable_on_demand_delivery && deliveryTime.asap) return true;
      if (settings.enable_scheduled_delivery && deliveryTime.scheduled)
        return true;
    }

    if (settings.enable_pickup) {
      if (settings.enable_on_demand_pickup && deliveryTime.asap) return true;
      if (settings.enable_scheduled_pickup && deliveryTime.pickup) return true;
    }

    return false;
  };

  getVat = (deliveryCharge, loyaltyPoints = 0) => {
    if (
      this.props.settings.enable_vat &&
      this.props.settings.enable_vat_staff &&
      this.props.settings.vat_rate > 0
    ) {
      let excludedItemsPrice = 0;
      let excludeVat = this.props.cart.cart.some(
        (item) => item.excludeVat === true,
      );

      if (excludeVat) {
        excludedItemsPrice = this.props.cart.cart.reduce((acc, item) => {
          if (item.excludeVat) {
            return (
              acc +
              (item.quantity * item.total_price +
                item.quantityExcludedOptionsTotal)
            );
          }
          return acc;
        }, 0);
      }
      excludedItemsPrice = this.props.cart.price - excludedItemsPrice;
      if (excludeVat) {
        const discountWithoutVatItem = getOrderDiscount(
          excludedItemsPrice,
          this.props.cart.cart,
          this.props.applied_promo,
          this.props.discounts,
          this.props.smart_promos,
        );

        const total = this.getTotal(
          excludedItemsPrice,
          this.props.applied_promo,
          this.props.discounts,
          discountWithoutVatItem,
          this.props.settings.remove_delivery_charge_from_vat
            ? 0
            : parseFloat(
                this.props.shipping.data?.data?.quote_data?.shipping_charge ||
                  0,
              ) ||
                deliveryCharge?.price ||
                0,
          !!this.props.cart.charged_items,
          loyaltyPoints,
        );

        return this.props.settings.enable_vat_with_product_price
          ? (total - total / (1 + this.props.settings.vat_rate)).toFixed(
              this.props.settings.currency_decimals,
            )
          : parseFloat(
              parseFloat(total) * parseFloat(this.props.settings.vat_rate),
            ).toFixed(this.props.settings.currency_decimals);
      } else {
        const { settings, cart } = this.props;
        const discount = getOrderDiscount(
          cart.price,
          cart.cart,
          this.props.applied_promo,
          this.props.discounts,
          this.props.smart_promos,
        );
        const total = this.getTotal(
          cart.price,
          this.props.applied_promo,
          this.props.discounts,
          discount,
          this.props.settings.remove_delivery_charge_from_vat
            ? 0
            : (this.isInternationalDelivery() &&
                parseFloat(
                  this.props.shipping.data?.data?.quote_data?.shipping_charge ||
                    0,
                )) ||
                (this.isInternationalDelivery() && !this.props.aramex_error
                  ? parseFloat(this.props.shipping.data?.total_value || 0)
                  : false) ||
                deliveryCharge?.price ||
                0,
          !!this.props.cart.charged_items,
          loyaltyPoints,
        );

        return settings.enable_vat_with_product_price
          ? (total - total / (1 + settings.vat_rate)).toFixed(
              settings.currency_decimals,
            )
          : parseFloat(
              parseFloat(total) * parseFloat(settings.vat_rate),
            ).toFixed(settings.currency_decimals);
      }
    } else {
      return 0;
    }
  };

  placeOrderCalled = false;
  placeOrder = async () => {
    if (this.placeOrderCalled == true) return;
    this.placeOrderCalled = true;
    const settings = this.props.settings;
    const isVerified = localStorage.getItem("phone_verified");
    if (
      settings.enable_phone_verification &&
      (!isVerified || isVerified !== this.props.customerContact?.phone) &&
      ((this.state.method === "cash" &&
        settings.enable_phone_verification_cash_only) ||
        !settings.enable_phone_verification_cash_only)
    ) {
      localStorage.removeItem("phone_verification");
      this.setState({ verifyPhoneModalOpen: true });
      this.placeOrderCalled = false;
      return;
    }

    const { language } = this.props;
    moment.locale("en");

    if (
      settings.busy_until_active &&
      settings.busy_until_time &&
      settings.busy_until_date &&
      !settings.allow_preordering &&
      ((compareTime(settings.busy_until_time, moment().format("HH:mm:ss")) ==
        1 &&
        moment(settings.busy_until_date).format("YYYY-MM-DD") ==
          moment().format("YYYY-MM-DD")) ||
        moment(settings.busy_until_date).format("YYYY-MM-DD") >
          moment().format("YYYY-MM-DD"))
    ) {
      this.setState({ busyDialogOpen: true });
      return;
    }

    this.setState({ loading: true });

    let tapV3Token = null;
    if (
      this.state.method === "tap_v2_credit" &&
      window.tapObject &&
      settings.enable_tap_v3_credit
    ) {
      const tapRes = await window.tapObject.createToken(window.tapCardObject);
      if (tapRes.error) {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
        this.setState({ tapCardError: tapRes.error.message, loading: false });
        this.placeOrderCalled = false;
        return;
      } else {
        tapV3Token = tapRes.id;
      }
    }

    const bypassMOV = this.props.applied_promos.some((promo) => {
      return promo?.bypassMOV;
    });

    let promise = this.props.promise;
    let obj;
    let url = `/promise_place/`;
    const dineInOrderID =
      localStorage.getItem("dine_in_order_id") ||
      this.props?.address?.dineInOrderID;
    const dineInSessionID =
      localStorage.getItem("dineInSessionID") ||
      this.props.address?.dineInSessionID;

    if (this.props.settings.enable_table_qr) {
      const dineInExpirationTime =
        localStorage.getItem("dineInExpirationTime") ||
        this.props.address?.dineInExpirationTime;
      if (
        !dineInExpirationTime ||
        dineInExpirationTime <= new Date().getTime()
      ) {
        this.props.modifyAddress({ parkingNumber: "", token: null });
        try {
          instance.post("log_error/", {
            title: "Dine in Reset",
            server_open_date: this.props.store.today_date,
            url: window.location.href,
            dineInOrderID: dineInOrderID,
            dineInSessionID: dineInSessionID,
            localExipry: dineInExpirationTime,
            localNowDate: new Date().getTime(),
            zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            agent: navigator.userAgent,
          });
        } catch (error) {}
        this.props.history.replace("/");
        return;
      }
    }

    const checkGiftUnknownLocation =
      this.props.settings.enable_gifts &&
      this.props.settings.enable_gifts_staff &&
      this.props.promise.isGift &&
      this.props.settings.enable_unknown_gift_recipient_location &&
      this.props.promise.unknown_location;

    let on_demand_text = undefined;
    const orderPlacedById = localStorage.getItem("orderPlacedById");
    if (
      this.props.deliveryTime.type === "asap" &&
      settings.enable_on_demand_custom_string &&
      !this.props.deliveryTime.isPickup &&
      !this.props.has_preordering
    ) {
      on_demand_text =
        this.props.language === "arabic"
          ? settings.on_demand_custom_string_ar
          : settings.on_demand_custom_string;
    }
    if (
      this.props.deliveryTime.type === "asap" &&
      settings.enable_on_demand_custom_string_pickup &&
      this.props.deliveryTime.isPickup &&
      !this.props.has_preordering
    ) {
      on_demand_text =
        this.props.language === "arabic"
          ? settings.on_demand_pickup_custom_string_ar
          : settings.on_demand_pickup_custom_string;
    }
    try {
      const res = await instance.post(
        url,
        {
          ...this.props.address,
          ...this.props.customerContact,
          ...this.props.cart,
          ...this.state,
          ...this.props.branch,
          ...promise,
          seshStarted: localStorage.getItem("sessionStart"),
          anchorEl: null,
          expected_delivery_date: this.props.deliveryTime.expected_date,
          expected_delivery_slot_start: this.props.deliveryTime.expected_start,
          expected_delivery_slot_end: this.props.deliveryTime.expected_end,
          is_asap: this.props.deliveryTime.type === "asap",
          on_demand_text: on_demand_text,
          isGift: promise.isGift || false,
          unknown_location:
            this.props.address?.selectedDeliveryType === 1
              ? false
              : promise.unknown_location,
          block:
            checkGiftUnknownLocation &&
            this.props.address?.selectedDeliveryType === 0
              ? "-"
              : this.props.address?.block,
          street:
            checkGiftUnknownLocation &&
            this.props.address?.selectedDeliveryType === 0
              ? "-"
              : this.props.address?.street,
          building:
            checkGiftUnknownLocation &&
            this.props.address?.selectedDeliveryType === 0
              ? "-"
              : this.props.address?.building,
          language: this.props.language,
          fbc_2: localStorage.getItem("fbc_2"), //facebook
          ttclid: localStorage.getItem("ttclid"), // tiktok
          sccid: localStorage.getItem("sccid"), // snapchat
          epik: localStorage.getItem("epik"), // pinterest
          order_placed_by_id: orderPlacedById,

          tapV3Token: tapV3Token,
          selected_country_code: this.props.currency.selected,
          no_cutlery: this.state.no_cutlery,
          exclude_delivery_charge_from_vat:
            this.props.settings.remove_delivery_charge_from_vat,

          dine_in_order_id: dineInOrderID,
          dine_in_session_id: dineInSessionID,
          bypass_minimum_order: bypassMOV,
        },
        {
          timeout: 30000,
          headers:
            this.props.settings.enable_orderpass &&
            this.props.orderPassStorefrontToken
              ? {
                  "X-OrderPass-Storefront-Token":
                    this.props.orderPassStorefrontToken,
                }
              : {},
        },
      );
      this.setState({ loading: false });
      setTimeout(() => {
        this.placeOrderCalled = false;
      }, 1000);
      if (res.data === "ResetDineIn") {
        this.props.modifyAddress({
          parkingNumber: "",
          token: null,
          dineInExpirationTime: null,
          dineInSessionID: null,
          dineInOrderID: null,
        });
        localStorage.removeItem("dine_in_order_id");
        localStorage.removeItem("dineInSessionID");
        this.props.history.replace("/");
        return;
      }

      if (res.data.paymentURL && res.data.paymentURL !== -1) {
        if (res.data.paymentURL != "Invalid") {
          this.props.savePastOrder(res.data.promise);
          this.props.saveLastOrder(res.data);
          if (
            (settings.enable_car_qr || !!this.props.address?.parkingNumber) &&
            !settings.enable_table_qr
          ) {
            this.props.modifyAddress({ parkingNumber: "" });
            this.props.turnOnMenu();
          }
          localStorage.removeItem("fbc_2");
          localStorage.removeItem("ttclid");

          window.location.href = res.data.paymentURL;
          return;
        } else {
          this.props.history.replace("/fail", {
            message:
              "The payment link could not be generated. Please contact us for help",
          });
          Sentry.captureException(
            new Error("Couldnt generate payment link"),
            (scope) => {
              scope.setExtra("cart", JSON.stringify(this.props.cart));
              scope.setExtra("branch", JSON.stringify(this.props.branch));
              scope.setExtra("customer", JSON.stringify(this.props.customers));
            },
          );
        }
      }
      if (res.data.message != "success" && !res.data.paymentURL) {
        this.props.history.replace("/fail", { message: res.data.message });
        Sentry.captureException(new Error(res.data.message), (scope) => {
          scope.setExtra("cart", JSON.stringify(this.props.cart));
          scope.setExtra("branch", JSON.stringify(this.props.branch));
          scope.setExtra("customer", JSON.stringify(this.props.customers));
        });
      } else {
        if (res.data.paymentURL !== "Invalid" || res.data.paymentURL === -1) {
          this.props.savePastOrder(res.data.promise);
          await this.props.clearCart(
            this.props.cart.promos ? this.props.cart.promos.id : null,
          );
          this.props.clearSpecialRequests();
          this.props.clearSpecialRemarksFiles();

          if (
            OfflinePaymentsMethods.includes(this.state.method) ||
            res.data.paymentURL === -1 ||
            res.data.total_price_with_discounts === 0
          ) {
            if (
              (settings.enable_car_qr || !!this.props.address?.parkingNumber) &&
              !settings.enable_table_qr
            ) {
              this.props.modifyAddress({ parkingNumber: "" });
              this.props.turnOnMenu();
            }
            localStorage.removeItem("fbc_2");
            localStorage.removeItem("ttclid");
            if (settings.enable_table_qr) {
              localStorage.setItem("dine_in_order_id", res.data.tracking_id);
              this.props.modifyAddress({ dineInOrderID: res.data.tracking_id });
              this.props.saveLastOrder(res.data);
            }

            this.props.resetFilters();
            if (this.props.promise.isGift) {
              this.props.resetGift();
              this.props.resetAddressForGift();
            }
            //this.props.setInventoryOnHandDisplay(res.data.cart)

            if (
              window.parent &&
              orderPlacedById
            ) // means order is being placed from an iframe
            {
              window.parent.postMessage(
                {
                  type: "ORDER_COMPLETED",
                  orderTrackingId: res.data.tracking_id,
                },
                "*",
              );
            }
            this.props.history.replace("/success", {
              tracking_id: res.data.tracking_id,
              has_downloadables: res.data.has_downloadables,
              total_price_with_discounts: res.data.total_price_with_discounts,
              cart: res.data.cart,
            });
          }

          if (this.props.smart_promos.length) {
            this.props.updatePromotions();
          }
        }
      }
    } catch (e) {
      console.error(e);
      this.props.history.replace("/fail", {
        message:
          language == "english"
            ? "Something wrong happened. Please try again, or contact us for help"
            : "حدث خطأ ما. الرجاء المحاولة مرة ثانية او تواصل معنا للمساعدة",
      });
      Sentry.captureException(e, (scope) => {
        scope.setExtra("cart", JSON.stringify(this.props.cart));
        scope.setExtra("branch", JSON.stringify(this.props.branch));
        scope.setExtra("customer", JSON.stringify(this.props.customers));
      });
    }
    // this.props.closeDrawer();
  };
  handleTypeChange = (val) => {
    this.setState({ type: val });
  };
  componentWillUnmount = () => {
    // this.props.resetDeliveryTime();
    if (this.deliveryTimeInterval) clearInterval(this.deliveryTimeInterval);
    document.removeEventListener("scroll", this.recommendationIsInViewport);
  };

  recommendationIsInViewport = () => {
    if (!this.recommendationsRef) return;
    try {
      const top = this.recommendationsRef.getBoundingClientRect().top;
      if (top <= window.innerHeight) {
        if (!this.state.recommendationVisibilityRegistered) {
          this.setState({ recommendationVisibilityRegistered: true });
          this.props.registerGlanceView({
            type: "product_recommendations_view",
            source: "checkout",
          });
        }
      }
    } catch (e) {}
  };

  calculateFinalTotal = () => {
    const { settings, cart, address } = this.props;

    let isPickup = false;
    if (
      (cart.delivered_items === 0 && cart.charged_items === 0) ||
      this.props.branch.isPickup ||
      address.selectedDeliveryType === 1
    )
      isPickup = true;

    const discount = getOrderDiscount(
      cart.price,
      cart.cart,
      this.props.applied_promo,
      this.props.discounts,
      this.props.smart_promos,
    );

    const showDelivery = !!this.props.cart.charged_items;

    let deliveryCharge;

    if (!isPickup) {
      if (!settings.is_branch_based_ordering) {
        deliveryCharge = this.props.areas.find(
          (dc) => dc.id == this.props.address?.area,
        );
      } else {
        let bdcObj = this.props.branch_delivery_charges.find(
          (bdc) => bdc.id == this.props.branch.bdc,
        );
        if (!bdcObj) return <Redirect to="/" />;
        deliveryCharge = bdcObj;
      }
    }

    const total = this.getTotal(
      this.props.cart.price,
      this.props.applied_promo,
      this.props.discounts,
      discount,
      (this.isInternationalDelivery() &&
        parseFloat(
          this.props.shipping.data?.data?.quote_data?.shipping_charge || 0,
        )) ||
        (this.isInternationalDelivery() && !this.props.aramex_error
          ? parseFloat(this.props.shipping.data?.total_value || 0)
          : false) ||
        deliveryCharge?.price ||
        0,
      showDelivery,
    );

    return total;
  };
  componentDidMount = () => {
    if (this.props.customerBin) {
      this.props.setCustomerBIN(null);
      if (
        this.props.smart_promos.some((sp) =>
          sp.conditions.some((c) =>
            ["card_scheme", "card_bank"].includes(c.type),
          ),
        )
      ) {
        this.props.updatePromotions();
      }
    }
    const { settings } = this.props;
    document.addEventListener("scroll", this.recommendationIsInViewport);
    window.scrollTo(0, 0);
    if (this.redirectIfAnythingIsMissing()) return;
    setTimeout(() => {
      this.setState({ placeOrderButtonEnabled: true });
    }, 1000);
    if (this.props.cart.delivered_items <= 0)
      this.props.setDeliveryTimeDidOpen(true);
    else {
      this.props.fetchDeliveryTime();
      if (!(settings.enable_car_qr || settings.enable_table_qr)) {
        this.deliveryTimeInterval = setInterval(() => {
          if (this.state.deliveryTimeFetchesCount <= 5) {
            this.props.fetchDeliveryTime();
            this.setState({
              deliveryTimeFetchesCount: this.state.deliveryTimeFetchesCount + 1,
            });
          }
        }, 1000 * 60);
      }
    }
    if (
      this.props.auth.user &&
      this.props.customers &&
      !_.isEmpty(this.props.customers) &&
      this.props.customerContact &&
      canUseSocialAuth(settings)
    )
      this.props.createCustomerWithAddressAndPhone();

    this.loadTapCardComponent();
    // this.getVat();
    this.calculateNutritions();

    this.categoriesMinList = this.props.categories.filter(
      (c) => c.minimum_order_value > 0,
    );

    if (
      this.props.promise.isGift &&
      settings.enable_force_gift_name_number &&
      (!this.props.promise.gift_name ||
        !this.props.promise.gift_recipient_number ||
        !this.props.promise.gift_recipient_number.split("-")[1])
    ) {
      this.props.enableIsGift(false);
    }

    if (settings.enable_tabby_widgets && this.state.method.includes("tabby")) {
      new window.TabbyCard({
        selector: "#tabbyCard", // empty div for TabbyCard.
        currency: settings.currency_iso, // required, currency of your product. AED|SAR|KWD|BHD|QAR only supported, with no spaces or lowercase.
        lang: this.props.language === "arabic" ? "ar" : "en", // Optional, language of snippet and popups.
        price: String(this.calculateFinalTotal()), // required, total price or the cart. 2 decimals max for AED|SAR|QAR and 3 decimals max for KWD|BHD.
        size: "wide", // required, can be also 'wide', depending on the width.
        theme: "default", // required, can be also 'default'.
        header: true, // if a Payment method name present already.
      });
    }
  };

  isInternationalDelivery = () => {
    if (
      (this.props.address?.country !== this.props.baseCountryID ||
        this.props.base_country_name === "Saudi Arabia") &&
      (this.props.settings.enable_dhl ||
        this.props.settings.enable_dhl_v2 ||
        this.props.settings.enable_aramex) &&
      this.props.address?.selectedDeliveryType === 0
    )
      return true;
    return false;
  };

  loadTapCardComponent = () => {
    if (!window.Tapjsli) return;
    const { language, settings } = this.props;
    if (!settings.tap_pk || !settings.enable_tap_v3_credit) return;
    try {
      var tap = window.Tapjsli(settings.tap_pk);
      window.tapObject = tap;
      var elements = tap.elements({});
      var style = {
        base: {
          color: "#535353",
          lineHeight: "18px",
          fontFamily: "sans-serif",
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "rgba(0, 0, 0, 0.26)",
            fontSize: "15px",
          },
        },
        invalid: {
          color: "red",
        },
      };
      // input labels/placeholders
      var labels = {
        cardNumber: "Card Number",
        expirationDate: "MM/YY",
        cvv: "CVV",
        cardHolder: "Card Holder Name",
      };
      //payment options
      var paymentOptions = {
        currencyCode: ["KWD", "USD", "SAR", "BHD", "OMR", "AED", "QAR"],
        labels: labels,
        TextDirection: "ltr",
      };
      //create element, pass style and payment options
      var card = elements.create("card", { style: style }, paymentOptions);
      window.tapCardObject = card;
      //mount element
      card.mount("#element-container");
      //card change event listener
      card.addEventListener("change", async (event) => {
        if (event.status === "invalid") {
          this.setState({ tapCardError: "" });
        }

        if (event.valid && event.BIN?.id != this.props.customerBin?.id) {
          if (
            this.props.smart_promos.some((sp) =>
              sp.conditions.some((c) =>
                ["card_scheme", "card_bank"].includes(c.type),
              ),
            )
          ) {
            await this.props.setCustomerBIN(event.BIN || {});
            this.props.updatePromotions();
          }
        }
      });
    } catch (e) {
      console.error(e);
      this.props.disableTapCredit();
    }
    // // Handle form submission
    // var form = document.getElementById("form-container");
    // form.addEventListener("submit", (event) => {
    //   event.preventDefault();

    // });
  };
  componentDidUpdate = (prevProps, prevState) => {
    const { settings } = this.props;
    const savedAddresses = getSavedAddresses(
      this.props.auth,
      this.props.orderPassAddresses,
      settings,
    );
    if (this.state.loading) return;
    if (savedAddresses.length) {
      if (
        settings.is_branch_based_ordering &&
        (this.props.branch.bdc !== prevProps.branch.bdc ||
          this.props.branch.branch !== prevProps.branch.branch)
      ) {
        this.props.fetchDeliveryTime();
      } else if (
        !settings.is_branch_based_ordering &&
        this.props.address?.country !== prevProps.address?.country &&
        this.props.address?.selectedDeliveryType === 0 &&
        prevProps.address?.selectedDeliveryType === 0
      )
        this.props.fetchDeliveryTime();
    }
    if (
      this.props.cart.promo_items.length !== prevProps.cart.promo_items.length
    ) {
      this.props.fetchDeliveryTime();
    }

    if (this.props.categories?.length != prevProps?.categories?.length) {
      this.categoriesMinList = this.props.categories.filter(
        (c) => c.minimum_order_value > 0,
      );
    }

    if (
      settings.enable_tabby_widgets &&
      this.state.method.includes("tabby") &&
      (this.props.language !== prevProps.language ||
        this.props.cart.price !== prevProps.cart.price ||
        prevState.method !== "tabby")
    ) {
      this.refreshTabbyWidget();
      new window.TabbyCard({
        selector: "#tabbyCard", // empty div for TabbyCard.
        currency: settings.currency_iso, // required, currency of your product. AED|SAR|KWD|BHD|QAR only supported, with no spaces or lowercase.
        lang: this.props.language === "arabic" ? "ar" : "en", // Optional, language of snippet and popups.
        price: String(this.calculateFinalTotal()), // required, total price or the cart. 2 decimals max for AED|SAR|QAR and 3 decimals max for KWD|BHD.
        size: "wide", // required, can be also 'wide', depending on the width.
        theme: "default", // required, can be also 'default'.
        header: true, // if a Payment method name present already.
      });
    }
  };

  Get_Categories_Minimum_Order_Conditions = () => {
    let conditions_left = [];
    let category;
    let { cart_categories_min, language, settings } = this.props;

    const currency = getCurrencyIso(settings, language);
    for (let i = 0; i < this.categoriesMinList.length; i++) {
      category = this.categoriesMinList[i];
      if (
        cart_categories_min[category.id] &&
        cart_categories_min[category.id] < category.minimum_order_value
      ) {
        let value_difference;
        if (!cart_categories_min[category.id]) {
          value_difference = parseFloat(category.minimum_order_value).toFixed(
            3,
          );
        } else {
          value_difference = parseFloat(
            category.minimum_order_value - cart_categories_min[category.id],
          ).toFixed(settings.currency_decimals);
        }

        language == "english"
          ? conditions_left.push(
              `Purchase ${value_difference} ${currency} more from ${category.name}`,
            )
          : conditions_left.push(
              `شراء ${value_difference} ${currency} إضافية من ${category.ar_name}`,
            );
      }
    }
    if (
      preciseNumber(this.props.settings.minimum_order) >
      preciseNumber(this.props.cart.price)
    ) {
      const difference = (
        preciseNumber(this.props.settings.minimum_order) -
        preciseNumber(this.props.cart.price)
      ).toFixed(settings.currency_decimals);
      language == "english"
        ? conditions_left.push(`Purchase ${difference} ${currency} more `)
        : conditions_left.push(`شراء ${difference} ${currency} إضافية `);
    }
    return conditions_left;
  };

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleDialogClaimItems = () => {
    if (this.state.pending_items.length) {
      if (this.props.current_product) {
        this.props.setProduct();
      }
      let products = this.state.pending_items;
      this.props.history.replace(
        `/product/${products[0].category}/${
          products[0].parent ? products[0].parent + "/" : ""
        }${products[0].slug}`,
        {
          pending_items: products.slice(1),
          returnURL: "/checkout/confirmation",
        },
      );
    } else if (this.state.pending_category.length) {
      let categoriesPromo = this.state.pending_category;
      let categories = this.props.categories;

      let category = categories.find((c) =>
        categoriesPromo[0].categories.includes(c.id),
      );
      if (category) this.props.history.replace(`/category/${category.slug}`);
    }
    this.setState({ dialogOpen: false });
  };
  handleDialogContinue = () => {
    if (!this.state.loading) {
      this.setState({
        dialogOpen: false,
      });
      this.placeOrder();
    }
  };

  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  askForCarInfo = (branch) => {
    const { settings, branches } = this.props;
    if (
      (!settings.is_branch_based_ordering && settings.ask_for_car_info) ||
      (settings.is_branch_based_ordering &&
        branches.find((b) => b.id === branch)?.ask_for_car_info &&
        branch)
    ) {
      return true;
    }
    return false;
  };

  checkDialCodeMatchCountry = (customerPhone) => {
    const { countries, address } = this.props;

    if (!customerPhone || !address?.country) return false;

    const countryObj = countries.find((c) => c.id === address.country);

    if (!countryObj?.dial_code) return false;
    const phoneObj = parsePhoneNumberFromString(customerPhone);
    if (!phoneObj) return false;
    return (
      phoneObj.country?.toLowerCase() === countryObj.dial_code.toLowerCase()
    );
  };

  redirectIfAnythingIsMissing = () => {
    const {
      cart,
      address,
      settings,
      allow_only_pickup,
      areas,
      promise,
      allow_only_delivery,
      countries,
      branch_delivery_charges,
    } = this.props;
    const totalCartLength = cart.cart.length + cart.promo_items.length;
    if (totalCartLength <= 0) return "/";
    if (
      shouldRequireOrderPassVerification(
        settings,
        this.props.customerContact,
        this.props.orderPassVerifiedPhone,
        this.props.orderPassGuestBypassPhone,
      )
    )
      return "/checkout/details";
    if (
      !this.props.customerContact?.name?.trim() ||
      !this.props.customerContact?.phone ||
      (settings.email_required &&
        (!this.props.customerContact.email ||
          !this.validateEmail(this.props.customerContact.email)))
    )
      return "/checkout/details";

    const customerPhone = this.props.customerContact?.phone;
    const isEgyptianPhone = isEgyptPhone(customerPhone);
    let isValidPhone = isEgyptianPhone
      ? isEgyptianMobilePhoneNumber(customerPhone)
      : isValidPhoneNumber(customerPhone) || isVirginPhoneNumber(customerPhone);
    if (settings.enable_table_qr && !settings.require_dine_in_contact_info) {
      isValidPhone = true;
    }
    if (!isValidPhone) return "/checkout/details";

    if (
      settings.force_phone_code_match_country &&
      settings.enable_gcc &&
      !this.checkDialCodeMatchCountry(this.props.customerContact?.phone)
    )
      return "/checkout/details";

    if (settings.ask_for_civil_id && !this.props.customerContact.civilID)
      return "/checkout/details";
    if (
      !address ||
      address?.selectedDeliveryType === undefined ||
      (address?.selectedDeliveryType === 0 &&
        (!address?.country || !address?.area)) ||
      (address?.selectedDeliveryType === 1 && !address?.pickupArea)
    ) {
      if (cart.delivered_items || cart.charged_items) return "/select/branch";
    }

    let selectedArea;
    if (settings.is_branch_based_ordering) {
      selectedArea = branch_delivery_charges.find(
        (bdc) => bdc.area_id === address?.area,
      );
      if (selectedArea) {
        selectedArea = {
          name: selectedArea.area,
          province_name: selectedArea.province_en,
        };
      }
    } else {
      selectedArea = areas.find((a) => a.id === address?.area);
    }

    const mosquesSituationTing =
      selectedArea?.province_name === "Mosques" &&
      address.selectedDeliveryType === 0;

    let selectedCountry =
      countries && !!address
        ? countries.find((country) => country.id == this.props.address?.country)
        : null;
    const international = selectedCountry?.name === "International";
    const useAddressLines =
      international || selectedArea?.province_name === "Kashtat";
    if (
      (cart.delivered_items || cart.charged_items) &&
      address?.selectedDeliveryType === 0 &&
      (!address.block ||
        !address.street ||
        (!address.building && !useAddressLines)) &&
      !mosquesSituationTing
    ) {
      return "/checkout/address";
    }
    // Checking for the apartment in Qatar if the address is an Apartment or Office
    if (
      (cart.delivered_items || cart.charged_items) &&
      address?.selectedDeliveryType === 0 &&
      (!address.block || !address.street || !address.building) &&
      (address?.selectedAddressType === 1 || address?.selectedAddressType === 2)
    ) {
      let selectedCountry = this.props.countries
        ? this.props.countries.find((country) => country.id == address?.country)
        : null;
      if (!selectedCountry) {
        selectedCountry = { name: "Kuwait" };
      }
      if (selectedCountry.name === "Qatar" && !address?.apartment)
        return "/checkout/address";
    }

    if (
      selectedCountry?.name === "Saudi Arabia" &&
      (cart.delivered_items || cart.charged_items) &&
      address?.selectedDeliveryType === 0 &&
      (!address.paci || !isValidSaudiNationalAddress(address.paci))
    ) {
      return "/checkout/address";
    }
    if (settings.is_branch_based_ordering) {
      if (cart.delivered_items || cart.charged_items) {
        if (!this.props.branch.branch) {
          return "/select/branch";
        } else {
          if (!this.props.branch.isPickup) {
            const bdcObj = this.props.branch_delivery_charges.find(
              (bdc) => bdc.id === this.props.branch.bdc,
            );
            if (this.props.branch.bdc && !bdcObj) return "/select/branch";
          } else {
            const branchObj = this.props.branches.find(
              (b) => b.id === this.props.branch.branch,
            );
            if (this.props.branch.branch && !branchObj) return "/select/branch";
          }
        }
      }
    }

    if (address?.selectedDeliveryType === 1) {
      if (!this.props.branches.find((b) => b.id === address.pickupArea))
        return "/select/branch";
    }

    let isPickup = false;
    if (
      (cart.delivered_items === 0 && cart.charged_items === 0) ||
      this.props.branch.isPickup ||
      address.selectedDeliveryType === 1
    )
      isPickup = true;

    if (
      isPickup &&
      address &&
      address.selectedDeliveryType === 1 &&
      (cart.delivered_items || cart.charged_items) &&
      !settings.enable_pickup
    ) {
      return "/select/branch";
    } else if (
      !isPickup &&
      address &&
      address.selectedDeliveryType === 0 &&
      (cart.delivered_items || cart.charged_items) &&
      (!settings.enable_delivery || allow_only_pickup)
    ) {
      return "/select/branch";
    } else if (
      isPickup &&
      address &&
      address.selectedDeliveryType === 1 &&
      (cart.delivered_items || cart.charged_items) &&
      (!settings.enable_pickup || allow_only_delivery)
    ) {
      return "/select/branch";
    }

    const alHamraSituationTing =
      selectedArea &&
      ([
        "arraya tower",
        "arraya center",
        "nbk tower",
        "assima mall",
        "mazaya tower",
        "international hospital",
      ].some((a) => selectedArea.name.toLowerCase().includes(a)) ||
        ["Offices", "Mosques"].includes(selectedArea.province_name)) &&
      address.selectedDeliveryType === 0;
    if (
      !isPickup &&
      !alHamraSituationTing &&
      settings.force_geolocation &&
      !useAddressLines &&
      !promise.isGift &&
      settings.ask_for_map_address &&
      (!address.lat || !address.lng || !address.gpsConfirmed)
    ) {
      return "/checkout/address";
    }

    return false;
  };

  handleChangeCutlery = (event) => {
    this.setState({
      no_cutlery: event.target.checked,
    });
  };

  getMinimumOrderValue = (isPickup, discountTotal) => {
    const { cart, settings } = this.props;
    let cartTotal = cart.price;
    if (settings.apply_discount_to_min_order) {
      cartTotal -= discountTotal;
      cartTotal = Math.max(cartTotal, 0);
    }
    const bypassMOV = this.props.applied_promos.some((promo) => {
      return promo?.bypassMOV;
    });

    if (bypassMOV) return null;

    if (
      isPickup &&
      preciseNumber(settings.minimum_order_pickup) > preciseNumber(cartTotal)
    ) {
      return settings.minimum_order_pickup;
    }

    if (
      !isPickup &&
      preciseNumber(settings.minimum_order) > preciseNumber(cartTotal)
    ) {
      return settings.minimum_order;
    }

    return null;
  };

  calculateNutritions = () => {
    const { cart_items, store, promo_items, settings } = this.props;
    if (
      !settings.show_nutrition_facts ||
      !settings.show_nutrition_facts_checkout
    )
      return;

    let res = {};
    let totalCalories = 0;
    let totalProtein = 0;
    let totalCarbs = 0;
    let totalFats = 0;
    let isDairyFree = true;
    let isSugarFree = true;
    let isGlutenFree = false;
    let isNutFree = true;
    let isOrganic = true;
    let isVegan = true;
    let isVegetarian = true;
    let containsGluten = false;
    let containsNutsSesame = true;
    let containsDairy = true;
    let containsEgg = true;
    let containsSeafoodShellfish = true;
    let containsChilli = true;

    cart_items.concat(promo_items).forEach((item) => {
      let current_product = getProduct(
        store.categories,
        item.id,
        item.category_id,
        item.parent,
      );
      if (current_product) {
        totalCalories += item.quantity * current_product.calories;
        totalProtein += item.quantity * current_product.protein;
        totalCarbs += item.quantity * current_product.carbs;
        totalFats += item.quantity * current_product.fats;

        if (!current_product.dietary_restrictions?.includes("Dairy free"))
          isDairyFree = false;
        if (current_product.dietary_restrictions?.includes("Gluten free"))
          isGlutenFree = true;
        if (!current_product.dietary_restrictions?.includes("Sugar free"))
          isSugarFree = false;
        if (!current_product.dietary_restrictions?.includes("Nut free"))
          isNutFree = false;
        if (!current_product.dietary_restrictions?.includes("Vegan"))
          isVegan = false;
        if (!current_product.dietary_restrictions?.includes("Vegetarian"))
          isVegetarian = false;
        if (!current_product.dietary_restrictions?.includes("Organic"))
          isOrganic = false;
        if (
          current_product.dietary_restrictions?.includes("Gluten") &&
          !current_product.dietary_restrictions?.includes("Gluten free")
        )
          containsGluten = true;
        if (!current_product.dietary_restrictions?.includes("Nuts/Sesame"))
          containsNutsSesame = false;
        if (!current_product.dietary_restrictions?.includes("Dairy"))
          containsDairy = false;
        if (!current_product.dietary_restrictions?.includes("Egg"))
          containsEgg = false;
        if (
          !current_product.dietary_restrictions?.includes("Seafood/Shellfish")
        )
          containsSeafoodShellfish = false;
        if (!current_product.dietary_restrictions?.includes("Chilli"))
          containsChilli = false;

        let options = item.options;
        let currentProductOptions = current_product.options;
        let selected_option = {};

        if (options) {
          for (let [key, value] of Object.entries(options)) {
            let existOption = currentProductOptions.find(
              (element) => element.id == key,
            );
            selected_option = value.selectedOptions;
            if (existOption) {
              for (let [selected_key, selected_value] of Object.entries(
                selected_option,
              )) {
                let existChoice = existOption.choices.find(
                  (element) => element.id == selected_key,
                );

                totalCalories +=
                  selected_value.quantity *
                  existChoice.calories *
                  ((existOption.quantity_exclusive && 1) || item.quantity);
                totalProtein +=
                  selected_value.quantity *
                  existChoice.protein *
                  ((existOption.quantity_exclusive && 1) || item.quantity);
                totalCarbs +=
                  selected_value.quantity *
                  existChoice.carbs *
                  ((existOption.quantity_exclusive && 1) || item.quantity);
                totalFats +=
                  selected_value.quantity *
                  existChoice.fats *
                  ((existOption.quantity_exclusive && 1) || item.quantity);
                if (existChoice.dietary_restrictions) {
                  if (!existChoice.dietary_restrictions?.includes("Dairy free"))
                    isDairyFree = false;
                  if (existChoice.dietary_restrictions?.includes("Gluten free"))
                    isGlutenFree = true;
                  if (!existChoice.dietary_restrictions?.includes("Sugar free"))
                    isSugarFree = false;
                  if (!existChoice.dietary_restrictions?.includes("Nut free"))
                    isNutFree = false;
                  if (!existChoice.dietary_restrictions?.includes("Vegan"))
                    isVegan = false;
                  if (!existChoice.dietary_restrictions?.includes("Vegetarian"))
                    isVegetarian = false;
                  if (!existChoice.dietary_restrictions?.includes("Organic"))
                    isOrganic = false;
                  if (
                    existChoice.dietary_restrictions?.includes("Gluten") &&
                    !existChoice.dietary_restrictions?.includes("Gluten free")
                  )
                    containsGluten = true;
                  if (
                    !existChoice.dietary_restrictions?.includes("Nuts/Sesame")
                  )
                    containsNutsSesame = false;
                  if (!existChoice.dietary_restrictions?.includes("Dairy"))
                    containsDairy = false;
                  if (!existChoice.dietary_restrictions?.includes("Egg"))
                    containsEgg = false;
                  if (
                    !existChoice.dietary_restrictions?.includes(
                      "Seafood/Shellfish",
                    )
                  )
                    containsSeafoodShellfish = false;
                  if (!existChoice.dietary_restrictions?.includes("Chilli"))
                    containsChilli = false;
                }
              }
            }
          }
        }
      }
    });

    res = {
      totalCalories: totalCalories,
      totalProtein: totalProtein,
      totalCarbs: totalCarbs,
      totalFats: totalFats,
      isDairyFree: isDairyFree,
      isSugarFree: isSugarFree,
      isGlutenFree: isGlutenFree,
      isNutFree: isNutFree,
      isOrganic: isOrganic,
      isVegan: isVegan,
      isVegetarian: isVegetarian,
      containsGluten: containsGluten,
      containsNutsSesame: containsNutsSesame,
      containsDairy: containsDairy,
      containsEgg: containsEgg,
      containsSeafoodShellfish: containsSeafoodShellfish,
      containsChilli: containsChilli,
    };

    this.setState({ nutritionalFacts: res });
  };

  handleDHLerror = () => {
    return this.props.dhl_error ? this.props.settings.dhl_error : false;
  };

  refreshTabbyWidget = () => {
    try {
      const element = document.querySelector("#tabbyCard");
      if (element) {
        const parent = element.parentNode;
        const nextSibling = element.nextSibling;
        element.remove();

        const newElement = document.createElement("div");
        newElement.id = "tabbyCard";
        newElement.style =
          "display: grid; justify-content: center; width: 100%";

        if (nextSibling) {
          parent.insertBefore(newElement, nextSibling);
        } else {
          parent.appendChild(newElement);
        }
      }
    } catch (e) {}
  };

  getLoyaltyPoints = (total, deliveryCharge) => {
    const { user, appliedPromo, settings } = this.props;
    const avaialblePoints =
      user?.points - (appliedPromo?.loyalty_points_cost || 0);
    const vat = parseFloat(this.getVat(deliveryCharge)) || 0;
    const loyaltyPointsNeeded = Math.ceil(
      (total + vat) *
        (settings.loyalty_points_to_money_threshold /
          settings.loyalty_points_to_money_conversion_rate),
    );
    const loyaltyPointsToUse = Math.min(
      Math.floor(avaialblePoints / settings.loyalty_points_to_money_threshold) *
        settings.loyalty_points_to_money_threshold,
      loyaltyPointsNeeded,
    );

    return (
      (
        (loyaltyPointsToUse *
          settings.loyalty_points_to_money_conversion_rate) /
        settings.loyalty_points_to_money_threshold
      ).toFixed(settings.currency_decimals) || "-"
    );
  };

  render() {
    const {
      cart,
      address,
      cart_categories_min,
      settings,
      abandonedCartID,
      appliedPromotions,
      smart_promos,
    } = this.props;
    const { nutritionalFacts } = this.state;

    const totalCartLength = cart.cart.length + cart.promo_items.length;
    if (totalCartLength <= 0) return <Redirect to="/" />;
    const discount = getOrderDiscount(
      cart.price,
      cart.cart,
      this.props.applied_promo,
      this.props.discounts,
      this.props.smart_promos,
    );

    const shouldRedirect = this.redirectIfAnythingIsMissing();
    if (!!shouldRedirect) return <Redirect to={shouldRedirect} />;

    let isPickup = false;
    if (
      (cart.delivered_items === 0 && cart.charged_items === 0) ||
      this.props.branch.isPickup ||
      address.selectedDeliveryType === 1
    )
      isPickup = true;

    let deliveryCharge;

    if (!isPickup) {
      if (!settings.is_branch_based_ordering) {
        deliveryCharge = this.props.areas.find(
          (dc) => dc.id == this.props.address?.area,
        );
      } else {
        let bdcObj = this.props.branch_delivery_charges.find(
          (bdc) => bdc.id == this.props.branch.bdc,
        );
        if (!bdcObj) return <Redirect to="/" />;
        deliveryCharge = bdcObj;
      }
    }

    const language = this.props.language;
    let customTexts = settings.custom_texts;
    if (!customTexts) {
      customTexts = {
        place_order: "Place Order",
        place_order_ar: "مراجعة الطلب",
        checkout_checkable_text: "Please check all the boxes",
        checkout_checkable_text_ar: "الرجاء تحديد جميع المربعات",
      };
    }

    const showDelivery = !!cart.charged_items;

    // MOV
    const open = Boolean(this.state.anchorEl);
    const id = open ? "simple-popover" : undefined;

    let categories_minimum_conditions_left = [];
    if (
      !isPickup &&
      this.categoriesMinList &&
      this.categoriesMinList.length &&
      cart_categories_min
    ) {
      categories_minimum_conditions_left =
        this.Get_Categories_Minimum_Order_Conditions();
    }
    const minimumOrderValue = this.getMinimumOrderValue(isPickup, discount);

    const cartURL = window.location.origin + "/?cart=" + abandonedCartID;
    const copyToClipboard = () => {
      navigator.clipboard.writeText(cartURL);
    };
    const handleSnackClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }

      this.setState({ snackOpen: false });
    };
    let pending_items_arr = [];
    let pending_category_arr = [];

    if (this.props.applied_promos.length) {
      if (this.props.discounts.products.length) {
        pending_items_arr = this.props.discounts.products.filter(
          (p) => p.quantity > 0,
        );
      }

      if (this.props.discounts.category_free.length) {
        pending_category_arr = this.props.discounts.category_free.filter(
          (c) => c.quantity > 0,
        );
      }
    }

    const showPromoProgressBar =
      smart_promos?.length === 1 &&
      !smart_promos[0].hide_promotion &&
      !appliedPromotions.find((p) => p.id === smart_promos[0].id);
    const total = this.calculateFinalTotal();
    const loyaltyPointConvert = this.getLoyaltyPoints(total, deliveryCharge);
    const orderPlacedById = localStorage.getItem("orderPlacedById");

    return (
      <div
        className=" w-100 mx-0"
        style={{
          overflowY: "scroll",
          overflowX: "hidden",
          minHeight: window.innerHeight,
        }}
      >
        <VerifyPhone
          open={this.state.verifyPhoneModalOpen}
          onClose={(verified) => {
            if (verified) this.placeOrder();
            this.setState({ verifyPhoneModalOpen: false });
          }}
          phone={this.props.customerContact?.phone}
          history={this.props.history}
        />

        {settings.busy_until_active &&
        settings.busy_until_date &&
        settings.busy_until_time &&
        !settings.allow_preordering ? (
          <StoreClosedDialog
            type={0}
            dialogOpen={this.state.busyDialogOpen}
            onClose={() =>
              this.setState({
                busyDialogOpen: false,
              })
            }
            untilDate={settings.busy_until_date}
            untilTime={settings.busy_until_time}
          />
        ) : null}
        <UnclaimedPromoDialog
          dialogOpen={this.state.dialogOpen}
          handleDialogContinue={async () => {
            if (
              cart.delivered_items > 0 &&
              !this.props.deliveryTime.didOpen &&
              !(settings.enable_car_qr || settings.enable_table_qr) &&
              settings.prompt_delivery_time &&
              (!this.props.deliveryTime.asap ||
                this.props.deliveryTime.scheduled ||
                this.props.deliveryTime.pickup)
            ) {
              this.setState({ fromActionButton: true });
              this.setState({ dialogOpen: false });
              await this.props.openDeliveryTimeDrawer(true);
            } else {
              this.handleDialogContinue();
            }
          }}
          onClose={() => this.setState({ dialogOpen: false })}
          handleDialogClaimItems={() => this.handleDialogClaimItems()}
        />

        <ProductHeader onBack={() => this.props.history.replace("/")} />
        <div className={"free-space-60"}></div>
        {this.props.deliveryTime.loading &&
          !(settings.enable_car_qr || settings.enable_table_qr) && (
            <div className="mt-5">
              <CircularProgress
                style={{
                  width: 25,
                  height: 25,
                  color: this.props.themeColor,
                }}
              />
            </div>
          )}
        {this.shouldShowDeliveryTime() &&
        !(settings.enable_car_qr || settings.enable_table_qr) ? (
          <DeliveryTimeV2
            handleDialogContinue={this.handleDialogContinue}
            fromActionButton={this.state.fromActionButton}
            setActionButtonFalse={() =>
              this.setState({ fromActionButton: false })
            }
          />
        ) : null}
        {settings.enable_gifts && settings.enable_gifts_staff && (
          <Gift
            SetGift={(gift_value) => this.props.enableIsGift(gift_value)}
            SetGiftMsg={(
              name,
              msg,
              number,
              link,
              anonymous,
              call_recipient,
              gift_wrapping,
            ) =>
              this.props.setGiftDetails(
                name,
                msg,
                number,
                link,
                anonymous,
                call_recipient,
                gift_wrapping,
              )
            }
            name={this.props.promise.gift_name}
            message={this.props.promise.gift_message}
            gift_recipient_number={this.props.promise.gift_recipient_number}
            gift_link={this.props.promise.gift_link}
            send_gift_anonymously={this.props.promise.send_gift_anonymously}
            call_recipient={this.props.promise.call_recipient}
            unknown_location={this.props.promise.unknown_location}
            gift_wrapping={this.props.promise.gift_wrapping}
            handleErrorChange={(type, value) => {
              if (type === "name") {
                this.setState({ errorName: value });
              }
              if (type === "number") {
                this.setState({ errorNumber: value });
              }
            }}
          />
        )}
        {(!this.props.settings.enable_table_qr ||
          this.props.settings.require_dine_in_contact_info) && (
          <DeliverTo history={this.props.history} />
        )}
        {isPickup &&
          this.props.branch &&
          !settings.is_menu &&
          this.askForCarInfo(this.props.branch.branch) && (
            <AdditionalInformation is_required={this.state.carInfoIsRequired} />
          )}

        {settings.show_nutrition_facts &&
          (nutritionalFacts?.totalCalories > 0 ||
            nutritionalFacts?.totalCarbs > 0 ||
            nutritionalFacts?.totalProtein > 0 ||
            nutritionalFacts?.totalFats > 0) && (
            <div style={{ marginTop: 30 }}>
              <NutritionalFacts
                nutritionalFacts={this.state.nutritionalFacts}
                fromPage={"checkout"}
              />
            </div>
          )}

        <Cart
          cart={this.props.cart.cart}
          promo_items={this.props.promo_items}
          calculateNutritions={() => this.calculateNutritions()}
        />

        {this.props.settings.enable_product_recommendations_staff &&
          this.props.settings.enable_product_recommendations_checkout && (
            <>
              <span
                ref={(el) => {
                  this.recommendationsRef = el;
                }}
              ></span>
              <ProductRecommendations cartBased fromCheckout />
            </>
          )}
        {settings.enable_coupons_store && <AppliedCoupons />}
        {/* <SpecialRemarks
          specialRemarks={this.state.special_remarks}
          setSpecialRemarks={(e) =>
            this.setState({ special_remarks: e.target.value })
          }
        /> */}

        {(!settings.enable_table_qr || settings.dine_in_payment_required) &&
          !orderPlacedById &&
          this.getTotal(
            cart.price,
            this.props.applied_promo,
            this.props.discounts,
            discount,
            deliveryCharge?.price || 0,
            showDelivery,
          ) != 0 && (
            <PaymentMethod
              setPaymentMethod={this.props.setPaymentMethod}
              vat={parseFloat(this.getVat(deliveryCharge)) || 0}
              handleChange={this.handleChange}
              value={this.state.method}
              paymentError={this.state.paymentError}
              isPickup={isPickup}
              total={this.getTotal(
                cart.price,
                this.props.applied_promo,
                this.props.discounts,
                discount,
                (this.isInternationalDelivery() &&
                  parseFloat(
                    this.props.shipping.data?.data?.quote_data
                      ?.shipping_charge || 0,
                  )) ||
                  (this.isInternationalDelivery() && !this.props.aramex_error
                    ? parseFloat(this.props.shipping.data?.total_value || 0)
                    : false) ||
                  deliveryCharge?.price ||
                  0,
                showDelivery,
              )}
              useCustomerWallet={this.state.useCustomerWallet}
              setUserCustomerWallet={(value) => {
                this.setState({
                  useCustomerWallet: value.target.checked,
                  useCustomerPoints: false,
                });
                if (
                  value.target.checked &&
                  this.props.auth.user?.wallet >=
                    this.getTotal(
                      cart.price,
                      this.props.applied_promo,
                      this.props.discounts,
                      discount,
                      deliveryCharge?.price || 0,
                      showDelivery,
                    )
                ) {
                  this.handleChange("wallet");
                } else if (
                  !value.target.checked &&
                  this.props.paymentMethod === "wallet"
                ) {
                  this.handleChange("none");
                }
              }}
              useCustomerPoints={this.state.useCustomerPoints}
              setUseCustomerPoints={(checked, hasEnoughPoints = false) => {
                this.setState({
                  useCustomerPoints: checked,
                  useCustomerWallet: false,
                });

                if (checked && hasEnoughPoints) {
                  this.handleChange("loyalty points");
                } else if (
                  !checked &&
                  this.props.paymentMethod === "loyalty points"
                ) {
                  this.handleChange("none");
                }
              }}
            />
          )}

        {this.state.method.includes("tamara") &&
          this.props.settings.enable_tamara_widgets && (
            <tamara-widget
              type="tamara-card-snippet"
              lang={this.props.language === "arabic" ? "ar" : "en"}
              country={this.props.store.default_dial_code.toUpperCase()}
            ></tamara-widget>
          )}

        {this.state.method.includes("tabby") &&
          this.props.settings.enable_tabby_widgets && (
            <div
              className="border-top border-bottom"
              style={{
                backgroundColor: "white",
                padding: "0px 10px",
                paddingTop: 10,
                width: "100%",
              }}
            >
              <div
                id="tabbyCard"
                style={{
                  width: "100%",
                  display: "grid",
                  justifyContent: "center",
                }}
              ></div>
            </div>
          )}

        {this.props.settings.enable_no_cutlery && (
          <div
            style={{
              marginTop: 30,
            }}
          >
            <p
              className="box-title"
              style={{ textAlign: language === "arabic" ? "right" : "left" }}
            >
              {language === "arabic" ? "دون ادوات الطعام" : "No Cutlery"}
            </p>
            <div
              className="border-top border-bottom w-100 mx-0 mb-3 py-4"
              style={{
                backgroundColor: "white",
                display: "flex",
                padding: 15,
                justifyContent: "space-between",
                direction: language === "arabic" ? "rtl" : "ltr",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <RestaurantIcon
                  style={{
                    marginRight: language === "arabic" ? 0 : 15,
                    marginLeft: language === "arabic" ? 15 : 0,
                  }}
                />
                <span>
                  {language === "arabic"
                    ? customTexts.no_cutlery_ar
                    : customTexts.no_cutlery}
                </span>
              </div>
              <Checkbox
                checkedIcon={
                  <CheckBoxIcon style={{ color: this.props.themeColor }} />
                }
                checked={this.state.no_cutlery}
                onChange={this.handleChangeCutlery}
              />
            </div>
          </div>
        )}
        {settings.enable_special_remarks_files && (
          <SpecialRemarksFile
            specialRemarksFileUrl={this.props.promise.special_remarks_file_url}
            specialRemarksFileName={
              this.props.promise.special_remarks_file_name
            }
            setSpecialRemarksFiles={(e, name) =>
              this.props.setSpecialRemarksFiles(e, name)
            }
          />
        )}
        {this.isInternationalDelivery() &&
        (this.props.settings.enable_dhl_dynamic_rate ||
          this.props.settings.enable_dhl_v2) ? (
          <Shipping />
        ) : null}

        {this.isInternationalDelivery() && this.props.settings.enable_aramex ? (
          <AramexShipping />
        ) : null}

        <div
          className="my-5"
          style={{
            display: this.state.method === "tap_v2_credit" ? "block" : "none",
          }}
        >
          <p
            className="box-title"
            style={{ textAlign: language === "arabic" ? "right" : "left" }}
          >
            {language === "arabic" ? "تفاصيل البطاقة" : "Card Details"}
          </p>
          {this.state.tapCardError && (
            <p
              style={{
                color: "red",
                textAlign: "left",
                padding: "0px 10px",
                fontWeight: "bold",
              }}
            >
              * {this.state.tapCardError}
            </p>
          )}
          <form id="form-container" method="post" action="/charge">
            <div id="element-container"></div>
          </form>
        </div>

        <StaticPages
          from={"Confirmation"}
          setStaticPagesCheckableEnabled={this.setStaticPagesCheckableEnabled}
          setStaticPagesCheckableChecked={this.setStaticPagesCheckableChecked}
        />

        <TotalCharge
          useCustomerPoints={this.state.useCustomerPoints}
          loyaltyPointConvert={parseFloat(loyaltyPointConvert)}
          deliveryPrice={
            (this.isInternationalDelivery() &&
              this.props.shipping.data?.data?.quote_data?.shipping_charge) ||
            (this.isInternationalDelivery() && !this.props.aramex_error
              ? parseFloat(this.props.shipping.data?.total_value || 0)
              : false) ||
            (deliveryCharge ? deliveryCharge.price : 0)
          }
          total={this.getTotal(
            cart.price,
            this.props.applied_promo,
            this.props.discounts,
            discount,
            (this.isInternationalDelivery() &&
              parseFloat(
                this.props.shipping.data?.data?.quote_data?.shipping_charge ||
                  0,
              )) ||
              (this.isInternationalDelivery() && !this.props.aramex_error
                ? parseFloat(this.props.shipping.data?.total_value || 0)
                : false) ||
              deliveryCharge?.price ||
              0,
            showDelivery,
            loyaltyPointConvert,
          )}
          vat={this.getVat(deliveryCharge)}
          subtotal={cart.price}
          discount={discount}
          showDelivery={
            showDelivery && this.props.address
              ? this.props.address.selectedDeliveryType === 0
                ? true
                : false
              : false
          }
          method={this.state.method}
          isInternationalDelivery={this.isInternationalDelivery()}
          showPromoProgressBar={showPromoProgressBar}
        />
        <div
          className={
            (this.props.applied_promo &&
              this.props.applied_promo.discount_type != "delivery") ||
            (settings.enable_vat &&
              settings.enable_vat_staff &&
              settings.vat_rate > 0)
              ? showPromoProgressBar
                ? "free-space-240"
                : "free-space-210"
              : "free-space-190"
          }
        ></div>

        {this.state.method !== "share" ? (
          <ActionButton
            errorName={this.state.errorName}
            errorNumber={this.state.errorNumber}
            from_confirmation={true}
            total={
              settings.apply_discount_to_min_order
                ? (this.props.cart.price - discount).toFixed(
                    settings.currency_decimals,
                  )
                : this.props.cart.price.toFixed(settings.currency_decimals)
            }
            Show_Modal={(e) => this.handleOpen(e)}
            disabled={
              minimumOrderValue > 0 ||
              categories_minimum_conditions_left.length ||
              (isPickup &&
                ((this.state.carInfoIsRequired?.["make_is_required"] &&
                  !this.props.address.make?.trim()) ||
                  (this.state.carInfoIsRequired?.["color_is_required"] &&
                    !this.props.address.color?.trim()) ||
                  (this.state.carInfoIsRequired?.["plate_is_required"] &&
                    !this.props.address.plateNumber?.trim()))) ||
              (this.props.promise.isGift &&
                (this.state.errorName || this.state.errorNumber)) ||
              (settings.enable_special_remarks_files &&
                settings.special_remarks_files_required &&
                !this.props.promise.special_remarks_file_url)
            }
            carInfoIsRequired={this.state.carInfoIsRequired}
            showCategoryMinOrder={categories_minimum_conditions_left.length > 0}
            minimumOrderValue={minimumOrderValue}
            isPickup={isPickup}
            action={
              this.state.placeOrderButtonEnabled &&
              (!this.state.loading ? (
                this.state.staticPagesCheckableEnabled &&
                !this.state.staticPagesCheckableChecked ? (
                  language == "english" ? (
                    customTexts.checkout_checkable_text
                  ) : (
                    customTexts.checkout_checkable_text_ar
                  )
                ) : language == "english" ? (
                  customTexts.place_order
                ) : (
                  customTexts.place_order_ar
                )
              ) : (
                <span>
                  <CircularProgress
                    style={{ width: 30, height: 30, color: "white" }}
                  />
                </span>
              ))
            }
            onClick={async () => {
              if (
                this.state.placeOrderButtonEnabled &&
                !this.props.deliveryTime.loading &&
                !this.state.loading
              ) {
                if (cart.delivered_items > 0 && !settings.enable_table_qr) {
                  if (
                    !this.props.deliveryTime.asap &&
                    !this.props.deliveryTime.scheduled &&
                    !this.props.deliveryTime.pickup
                  ) {
                    return;
                  }
                  if (this.state.deliveryTimeFetchesCount >= 5) {
                    window.location.reload();
                    return;
                  }
                }
                if (
                  cart.delivered_items > 0 &&
                  !this.props.deliveryTime.didOpen &&
                  !(settings.enable_car_qr || settings.enable_table_qr) &&
                  settings.prompt_delivery_time &&
                  settings.enable_place_order_directly === false
                ) {
                  if (
                    !this.props.deliveryTime.asap ||
                    this.props.deliveryTime.scheduled ||
                    this.props.deliveryTime.pickup
                  ) {
                    await this.props.openDeliveryTimeDrawer(true);
                    return;
                  }
                }

                if (this.state.method == "none") {
                  if (
                    (!settings.enable_table_qr ||
                      settings.dine_in_payment_required) &&
                    this.getTotal(
                      cart.price,
                      this.props.applied_promo,
                      this.props.discounts,
                      discount,
                      deliveryCharge?.price || 0,
                      showDelivery,
                    ) != 0
                  ) {
                    this.setState({ paymentError: true });
                    window.scrollTo({
                      top: document.body.scrollHeight,
                      behavior: "smooth",
                    });

                    return;
                  } else {
                    this.state.method = "cash";
                  }
                }
                if (this.state.method == "wallet") {
                  if (
                    this.getTotal(
                      cart.price,
                      this.props.applied_promo,
                      this.props.discounts,
                      discount,
                      deliveryCharge?.price || 0,
                      showDelivery,
                    ) > this.props.user.wallet
                  ) {
                    this.setState({ paymentError: true });
                    window.scrollTo({
                      top: document.body.scrollHeight,
                      behavior: "smooth",
                    });

                    return;
                  }
                }
                if (!pending_items_arr.length && !pending_category_arr.length) {
                  if (settings.enable_place_order_directly === false) {
                    this.handleDialogContinue();
                  } else {
                    if (
                      cart.delivered_items > 0 &&
                      !this.props.deliveryTime.didOpen &&
                      !(settings.enable_car_qr || settings.enable_table_qr) &&
                      settings.prompt_delivery_time &&
                      settings.enable_place_order_directly === true
                    ) {
                      if (
                        !this.props.deliveryTime.asap ||
                        this.props.deliveryTime.scheduled ||
                        this.props.deliveryTime.pickup
                      ) {
                        await this.props.openDeliveryTimeDrawer(true);
                        this.setState({ fromActionButton: true });
                        return;
                      }
                    }
                  }
                } else {
                  this.setState({
                    dialogOpen: true,
                    pending_items: pending_items_arr,
                    pending_category: pending_category_arr,
                  });
                  return;
                }
                if (settings.prompt_delivery_time === false) {
                  this.handleDialogContinue();
                }

                this.placeOrder();
              }
            }}
            placeOrderButtonDisabled={
              !this.state.placeOrderButtonEnabled ||
              (this.state.staticPagesCheckableEnabled &&
                !this.state.staticPagesCheckableChecked) ||
              (this.isInternationalDelivery() && this.props.shipping.loading) ||
              (this.isInternationalDelivery() && this.handleDHLerror())
            }
          />
        ) : (
          <div
            style={{
              backgroundColor: "white",
              paddingBottom: 8,
              marginBottom: 0,
              height: 60,
              zIndex: this.props.isCartButton ? 3000 : 10,
              direction: language === "arabic" ? "rtl" : "ltr",
            }}
            className={
              language == "english"
                ? "action-button-english"
                : "action-button-arabic"
            }
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "49.3% 49.3%",
                columnGap: 7,
                width: "100%",
              }}
            >
              <div
                style={{
                  border: "1px solid " + this.props.themeColor,
                  borderRadius: 5,
                  textAlign: "center",
                  height: 40,
                  display: "grid",
                  justifyContent: "center",
                  alignContent: "center",
                  color: this.props.themeColor,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.setState({ snackOpen: true });
                  copyToClipboard();
                }}
              >
                {language === "arabic" ? "نسخ الرابط" : "Copy Link"}
              </div>
              <div
                style={{
                  border: "1px solid #23D366",
                  background: "#23D366",
                  borderRadius: 5,
                  color: "white",
                  textAlign: "center",
                  height: 40,
                  display: "grid",
                  justifyContent: "center",
                  alignContent: "center",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.open(
                    "https://" +
                      (isMobileOrTablet() ? "api" : "web") +
                      ".whatsapp.com/send?text=" +
                      cartURL,
                    "_blank",
                  )
                }
              >
                {language === "arabic" ? "ارسال واتساب" : "Send WhatsApp"}
              </div>
            </div>
          </div>
        )}
        <Popover
          PaperProps={{ style: { padding: 10 } }}
          id={id}
          open={open && categories_minimum_conditions_left.length}
          anchorEl={this.state.anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <div
            className={`${
              language === "english"
                ? "pr-2 pl-1 text-left"
                : "pr-2 pl-3 text-right"
            }`}
            style={{
              fontWeight: "bold",
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              direction: language == "english" ? "ltr" : "rtl",
            }}
          >
            <p
              className={`${
                language === "english" ? "m-3 text-left" : "m-3 text-right"
              }`}
            >
              {language == "english"
                ? "To proceed, you need to:"
                : "لإكمال عملية الشراء, يجب:"}
            </p>
            <ul className={`${language === "english" ? "" : "text-right"}`}>
              {categories_minimum_conditions_left.map((c, index) => (
                <li key={"condition" + index}>{c}</li>
              ))}
            </ul>
          </div>
        </Popover>

        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={3000}
          onClose={handleSnackClose}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert onClose={handleSnackClose} severity="success">
            {language == "english"
              ? "Cart link copied successfully!"
              : "تم نسخ رابط السلة"}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    cart_items: state.cart.cart,
    settings: state.store.store.settings,
    categories: state.store.store.categories,
    customerContact: state.customers?.customerContact,
    orderPassVerifiedPhone: state.customers?.orderPassVerifiedPhone,
    orderPassStorefrontToken: state.customers?.orderPassStorefrontToken,
    orderPassGuestBypassPhone: state.customers?.orderPassGuestBypassPhone,
    address: state.customers?.address,
    customers: state.customers,
    cart: state.cart,
    deliveryCharges: state.store.store.delivery_charges,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    applied_promo: state.cart.promos,
    promise: state.promise,
    areas: state.store.store.areas,
    branch: state.branch,
    discounts: state.cart.discounts,
    promo_items: state.cart.promo_items,
    smart_promos: state.store.store.smart_promos,
    cart_categories_min: state.cart.categories_min_order,
    applied_promos: state.cart.smart_promos,
    branches: state.store.store.branches,
    deliveryTime: state.deliveryTime,
    current_product: state.store.current_product,
    auth: state.auth,
    orderPassAddresses: state.customers.orderPassAddresses || [],
    promos: state.cart.promos,
    allow_only_pickup: state.cart.pickup_only_items > 0,
    allow_only_delivery: state.cart.delivery_only_items > 0,
    currency: state.currency,
    countries: state.store.store.all_countries || state.store.store.countries,
    baseCountryID: state.store.store.base_country_id,
    shipping: state.shipping,
    abandonedCartID: state.abandonedCart.id,
    themeColor: state.store.store.settings.dark || "#0099cc",
    paymentMethod: state.cart.payment_method,
    store: state.store.store,
    dhl_error: state.shipping.dhl_error,
    aramex_error: state.shipping.aramex_error,
    user: state.auth.user,
    base_country_name: state.store.store.base_country,
    appliedPromotions: state.cart.smart_promos,
    has_preordering:
      state.cart.preordering_max_leadtime > 0 &&
      state.cart.preordered_items > 0,

    customerBin: state.customers.bin,
    appliedPromo: state.cart.promos,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    savePastOrder: (promiseID) => dispatch(savePastOrder(promiseID)),
    clearCart: (promo_id) => dispatch(clearCart(promo_id)),
    saveLastOrder: (response) => dispatch(saveLastOrder(response)),
    updatePromotions: () => dispatch(updatePromotions()),

    fetchDeliveryTime: () => dispatch(fetchDeliveryTime()),

    setDeliveryTimeDidOpen: (val) =>
      dispatch({ type: "SET_DELIVERY_TIME_DID_OPEN", payload: val }),

    resetDeliveryTime: () => dispatch({ type: "RESET_DELIVERY_TIME" }),
    openDeliveryTimeDrawer: (state) => dispatch(setDrawer(state)),

    setProduct: (product) => dispatch(setProduct(product)),
    createCustomerWithAddressAndPhone: () =>
      dispatch(createCustomerWithAddressAndPhone()),
    modifyAddress: (address) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: address }),
    turnOnMenu: () => dispatch({ type: "TURN_ON_MENU" }),
    clearSpecialRequests: () =>
      dispatch({ type: "SET_SPECIAL_REMARKS", payload: "" }),
    clearSpecialRemarksFiles: () =>
      dispatch({
        type: "SET_SPECIAL_REMARKS_FILES",
        payload: { url: null, name: null },
      }),
    registerGlanceView: (data) => dispatch(registerGlanceView(data)),
    disableTapCredit: () => dispatch({ type: "DISABLE_TAP_CREDIT" }),
    resetFilters: () => dispatch(resetFilter()),
    resetGift: () => dispatch({ type: "RESET_GIFTING" }),
    setPaymentMethod: (method) =>
      dispatch({ type: "SET_PAYMENT_METHOD", payload: method }),

    setInventoryOnHandDisplay: (cart) =>
      dispatch({
        type: "SET_INVENTORY_ON_HAND_DISPLAY",
        payload: cart,
      }),
    enableIsGift: (value) =>
      dispatch({ type: "ENABLE_IS_GIFT", payload: value }),
    setGiftDetails: (
      name,
      message,
      number,
      link,
      anonymous,
      call_recipient,
      gift_wrapping,
    ) =>
      dispatch({
        type: "SET_GIFT_DETAILS",
        payload: {
          name,
          message,
          number,
          link,
          anonymous,
          call_recipient,
          gift_wrapping,
        },
      }),
    resetAddressForGift: () =>
      dispatch({ type: "RESET_ADDRESS_FOR_UNKNOWN_GIFT_LOCATION" }),
    setSpecialRemarksFiles: (srf, name) =>
      dispatch({
        type: "SET_SPECIAL_REMARKS_FILES",
        payload: { url: srf, name: name },
      }),

    setCustomerBIN: (data) =>
      dispatch({ type: "SET_CUSTOMER_BIN", payload: data }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
export { OfflinePaymentsMethods };
